interface Props {
	children: React.ReactNode;
}

const GroupedFields = ({ children }: Props) => (
	<div className="w-full flex flex-col gap-x-4 gap-y-4 md:flex-row">{children}</div>
);
export default GroupedFields;
